function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("g", {
  fill: "#102E8E",
  fillRule: "nonzero",
  transform: "translate(3 3)"
}, React.createElement("path", {
  d: "M9 18c-4.963 0-9-3.992-9-8.9 0-3.4 2.013-6.55 5.128-8.022a.804.804 0 01.7.007.79.79 0 01.422.55c.075.385.379 1.279 1.559 1.279.825 0 1.217-.441 1.4-.812a.797.797 0 011.507.367c-.016.601.153 1.14.451 1.444.396.4 1.08.427 1.99.104a.797.797 0 01.912.28c.208.284.2.668-.018.944-.347.438-.38 1.08-.085 1.678.35.71 1.05 1.133 1.872 1.133.355 0 .668-.076.959-.23a.804.804 0 01.76.002.79.79 0 01.41.632l.006.098c.014.182.027.363.027.548C18 14.008 13.963 18 9 18zM5.5 3A7.65 7.65 0 002 9.407C2 13.594 5.368 17 9.508 17c3.974 0 7.237-3.14 7.492-7.095a3.822 3.822 0 01-.565.042c-1.442 0-2.723-.8-3.344-2.088a3.553 3.553 0 01-.35-1.866l-.136.003c-.822 0-1.531-.287-2.054-.829a3.077 3.077 0 01-.614-.958 3.259 3.259 0 01-1.636.415C7.063 4.624 6.044 4.012 5.5 3zM17 1.5a.5.5 0 11-1 0 .5.5 0 011 0z"
}), React.createElement("circle", {
  cx: 5,
  cy: 7,
  r: 1
}), React.createElement("circle", {
  cx: 6,
  cy: 11,
  r: 1
}), React.createElement("circle", {
  cx: 10,
  cy: 13,
  r: 1
}), React.createElement("circle", {
  cx: 10,
  cy: 8,
  r: 1
}), React.createElement("path", {
  d: "M14 1a1 1 0 11-2 0 1 1 0 012 0z"
}), React.createElement("circle", {
  cx: 16.5,
  cy: 4.5,
  r: 1
})));

var SvgIcCookie = function SvgIcCookie(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxnIGZpbGw9IiMxMDJFOEUiIGZpbGwtcnVsZT0ibm9uemVybyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik05IDE4Yy00Ljk2MyAwLTktMy45OTItOS04LjlDMCA1LjcgMi4wMTMgMi41NSA1LjEyOCAxLjA3OGEuODA0LjgwNCAwIDAgMSAuNy4wMDdjLjIxOC4xMDkuMzc1LjMxMy40MjIuNTUuMDc1LjM4NS4zNzkgMS4yNzkgMS41NTkgMS4yNzkuODI1IDAgMS4yMTctLjQ0MSAxLjQtLjgxMmEuNzk3Ljc5NyAwIDAgMSAxLjUwNy4zNjdjLS4wMTYuNjAxLjE1MyAxLjE0LjQ1MSAxLjQ0NC4zOTYuNCAxLjA4LjQyNyAxLjk5LjEwNGEuNzk3Ljc5NyAwIDAgMSAuOTEyLjI4Yy4yMDguMjg0LjIuNjY4LS4wMTguOTQ0LS4zNDcuNDM4LS4zOCAxLjA4LS4wODUgMS42NzguMzUuNzEgMS4wNSAxLjEzMyAxLjg3MiAxLjEzMy4zNTUgMCAuNjY4LS4wNzYuOTU5LS4yM2EuODA0LjgwNCAwIDAgMSAuNzYuMDAyYy4yMzYuMTI5LjM5LjM2Ny40MS42MzJsLjAwNi4wOThjLjAxNC4xODIuMDI3LjM2My4wMjcuNTQ4QzE4IDE0LjAwOCAxMy45NjMgMTggOSAxOHpNNS41IDNBNy42NSA3LjY1IDAgMCAwIDIgOS40MDdDMiAxMy41OTQgNS4zNjggMTcgOS41MDggMTdjMy45NzQgMCA3LjIzNy0zLjE0IDcuNDkyLTcuMDk1YTMuODIyIDMuODIyIDAgMCAxLS41NjUuMDQyYy0xLjQ0MiAwLTIuNzIzLS44LTMuMzQ0LTIuMDg4YTMuNTUzIDMuNTUzIDAgMCAxLS4zNS0xLjg2NmwtLjEzNi4wMDNjLS44MjIgMC0xLjUzMS0uMjg3LTIuMDU0LS44MjlhMy4wNzcgMy4wNzcgMCAwIDEtLjYxNC0uOTU4IDMuMjU5IDMuMjU5IDAgMCAxLTEuNjM2LjQxNUM3LjA2MyA0LjYyNCA2LjA0NCA0LjAxMiA1LjUgM3pNMTcgMS41YS41LjUgMCAxIDEtMSAwIC41LjUgMCAwIDEgMSAweiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSI1IiBjeT0iNyIgcj0iMSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSI2IiBjeT0iMTEiIHI9IjEiLz4KICAgICAgICAgICAgPGNpcmNsZSBjeD0iMTAiIGN5PSIxMyIgcj0iMSIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxMCIgY3k9IjgiIHI9IjEiLz4KICAgICAgICAgICAgPHBhdGggZD0iTTE0IDFhMSAxIDAgMSAxLTIgMCAxIDEgMCAwIDEgMiAweiIvPgogICAgICAgICAgICA8Y2lyY2xlIGN4PSIxNi41IiBjeT0iNC41IiByPSIxIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIcCookie as ReactComponent };